import React from 'react';
import DropDown from '../../DropDown';

const SchemeSelectionSelector = ({ template, state, setState, onUpdateTickerGroup, updateTickerStatus }) => {
	const { selectionGroups, selectedTickerGroup, tickers } = state;
	const tickerConf = template.ticker;
	const allOptions = tickerConf.documentSelectionOptions || {};
	const options = (selectedTickerGroup && allOptions[selectedTickerGroup.offerNumber]) || [];
	const selectedOption = options.find(opt => opt.value === tickers[0]);

	return (
		<div>
			<label className="label-input">{tickerConf.selectionName}</label>
			<DropDown clickable fullWidth value={selectedTickerGroup && selectedTickerGroup.offerName} maxDropdownHeight={"calc(98vh - 372px"}>
				{selectionGroups
					.filter((option) => tickerConf.schemeNumbers?.includes(option.offerNumber))
					.sort((a, b) => {
						if (!a.offerName) return -1;
						else if (!b.offerName) return 1;
						else return a.offerName.localeCompare(b.offerName);
					})
					.map((option, index) => (
						<li key={index} onClick={() => setState({ selectedTickerGroup: option, tickers: [""] }, onUpdateTickerGroup)}>
							{option.offerName}
						</li>
					))}
			</DropDown>
			{selectedTickerGroup && (
				<>
					<label className="label-input mt-l">{tickerConf.subSelectionName}</label>
					<DropDown clickable fullWidth value={selectedOption ? selectedOption.name : null} maxDropdownHeight={"calc(98vh - 472px"}>
						{options.map((option, index) => (
							<li key={index} onClick={() => setState({ tickers: [option.value] }, () => updateTickerStatus(true))}>
								{option.name}
							</li>
						))}
					</DropDown>
				</>
			)}
		</div>
	);
};

export default SchemeSelectionSelector;
